import React from 'react';
import classes from './offline-banner.module.scss';

type OfflineBannerProps = {
  isOffline: boolean;
};

// Summary: RTL Hebrew "no internet" banner shown at the POS shell top while connectivity is lost.
export const OfflineBanner: React.FC<OfflineBannerProps> = ({ isOffline }) => {
  if (!isOffline) {
    return null;
  }

  return (
    <div className={classes.banner} role="alert" data-testid="offline-banner">
      <span className={classes.dot} aria-hidden="true" />
      <span>אין חיבור לאינטרנט</span>
    </div>
  );
};
